// Utility to migrate legacy card relationships data to the new format
// Usage: Call this function with t, orgId, token, and the legacy data

import { trackSentryEvent } from "../analytics/sentry.js";

export async function migrateVersionToCardRelationshipsData({
  t,
  orgId,
  token,
  legacyData,
}) {
  const version = new Date().toISOString();
  trackSentryEvent("migration_legacy_data", {
    organization_id: orgId,
    dataKeys: Object.keys(legacyData).length,
    version,
  });

  if (process.env.POWERUP_NAME.includes("LOCAL")) {
    // For local dev, store the new format in Trello local storage
    await t.set("organization", "shared", "localCardRelationships", {
      version,
      data: legacyData,
    });
  } else {
    // POST to Netlify in new format
    await fetch("/.netlify/functions/cardRelationshipsApi", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        organizationId: orgId,
        version,
        data: legacyData,
      }),
    });
  }
  // Return the new format
  return { version, data: legacyData };
}
